import type {OrderDetailData} from 'modules/Orders/types';

import OrderProductItem from './components/OrderProductItem/OrderProductItem';

type OrderProductsProps = {
  data?: OrderDetailData;
};

const OrderProducts: React.FC<OrderProductsProps> = ({data}) => {
  return (
    <section className="flex flex-col">
      <div className="flex items-center justify-between p-2.5 text-body-sm">
        <span className="text-gray-09">لیست کالاها</span>
        <span className="text-gray-07">{data?.products?.length ?? 0} کالا</span>
      </div>
      <div className="flex flex-col">
        {data?.products?.map((product) => (
          <OrderProductItem key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default OrderProducts;
